module.exports = __webpack_public_path__ + "img/auth6.7724336e.png";